import { Feedback } from './feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SelfCheckFeedback extends Feedback {
  public static fromDto(dto: any): SelfCheckFeedback {
    const feedback: SelfCheckFeedback = new SelfCheckFeedback();
    Feedback.mapBaseProperties(feedback, dto);
    return feedback;
  }
}
